<p *ngIf="educationPhaseProgress">
  {{educationPhaseProgress.phaseName | localizedString}}
  {{educationPhaseProgress.attainedCredits || 0}}/{{educationPhaseProgress.targetCredits.min || 0}}
  {{'CREDITS' | transloco}}
</p>
